/**
 * Which screens actually hold a message and send it later.
 *
 * The offline banner is mounted once, above the router, so it speaks to every
 * surface in the app. It used to tell all of them the same thing — "messages
 * you send now queue locally and go out when you reconnect" — when exactly one
 * screen does that. On Diagnose, where most of a tech's day happens, a message
 * sent offline is simply gone.
 *
 * Keep this list honest. A surface belongs here only once it enqueues on
 * failure AND its queue is drained; adding a path here is a promise.
 */

/** Shop Chat. The one surface with a real outbox behind it. */
const QUEUEING_PATHS = ['/tech/chat'];

export function surfaceQueuesMessages(pathname: string): boolean {
  return QUEUEING_PATHS.some((base) => pathname === base || pathname.startsWith(`${base}/`));
}
